export const LOCATIONS_RESET_STATE = "LOCATIONS_RESET_STATE";
export const SET_LOCATIONS = "SET_LOCATIONS";
export const SET_CURRENT_LOCATION = "SET_CURRENT_LOCATION";
